import kemtai from './kemtai/locales';
import mixpanel from './mixpanel/locales';

export default {
  en: {
    ...kemtai.en,
    ...mixpanel.en,
  },
  es: {
    ...kemtai.es,
    ...mixpanel.es,
  },
  de: {
    ...kemtai.de,
    ...mixpanel.de,
  },
  cs: {
    ...kemtai.cs,
    ...mixpanel.cs,
  },
  ja: {
    ...kemtai.ja,
    ...mixpanel.ja,
  },
  sk: {
    ...kemtai.sk,
    ...mixpanel.sk,
  },
  it: {
    ...kemtai.it,
    ...mixpanel.it,
  },
  fr: {
    ...kemtai.fr,
    ...mixpanel.fr,
  },
  pl: {
    ...kemtai.pl,
    ...mixpanel.pl,
  },
  zh: {
    ...kemtai.zh,
    ...mixpanel.zh,
  },
};
